import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@env/environment';
import { LoggerService, LogLevel } from '@core/logger';
import { MenuService } from './menu.service';

@Injectable({
  providedIn: 'root',
})
export class StartupService {
  public constructor(
    private http: HttpClient,
    private loggerService: LoggerService,
    private menu: MenuService
  ) {}

  public async load(): Promise<void> {
    try {
      // NOTE: Set log level to Logger service
      this.loggerService.Level = environment.logLevel || LogLevel.All;

      /*
       * NOTE: Request Identity
       * This has to be adjusted to your needs
       * await coreUtility.requestStateAsync(this.store, coreStore.selectIdentityState, () =>
       *   identityStore.fetchIdentityAction()
       * );
       */

      /*
       * NOTE: Request Identity Roles
       * This has to be adjusted to your needs
       * this.store.dispatch(identityStore.fetchRolesAction());
       */

      // NOTE: Load sidemenu configuration from `menu.json` within the `assets/data` folder
      const menuJson: any = await this.http
        .get(`assets/data/menu.json?_t=${Date.now()}`)
        .toPromise();
      const translatedMenu = MenuService.recursiveMenuForTranslation(menuJson.menu, 'menu');
      this.menu.set(translatedMenu);
    } catch (error) {
      throw new Error('Failed to load startup data.');
    }
  }
}
